import React from "react";

export type PaymentState = "paid" | "partial" | "unpaid";

export const paymentStateOf = (fullyPaid: boolean, paidAmount: number): PaymentState => {
  if (fullyPaid) return "paid";
  if (paidAmount > 0) return "partial";
  return "unpaid";
};

const STATUS_STYLES: Record<PaymentState, { dot: string; text: string; bg: string; label: string }> = {
  paid: {
    dot: "bg-emerald-500",
    text: "text-emerald-700 dark:text-emerald-400",
    bg: "bg-emerald-50 dark:bg-emerald-900/20",
    label: "Opłacone",
  },
  partial: {
    dot: "bg-amber-500",
    text: "text-amber-700 dark:text-amber-400",
    bg: "bg-amber-50 dark:bg-amber-900/20",
    label: "Częściowo",
  },
  unpaid: {
    dot: "bg-red-500",
    text: "text-red-700 dark:text-red-400",
    bg: "bg-red-50 dark:bg-red-900/20",
    label: "Zaległość",
  },
};

export const paymentDotClass = (state: PaymentState): string => STATUS_STYLES[state].dot;

interface PaymentStatusBadgeProps {
  state: PaymentState;
  className?: string;
}

export const PaymentStatusBadge = ({ state, className = "" }: PaymentStatusBadgeProps) => {
  const s = STATUS_STYLES[state];
  return (
    <span
      className={`inline-flex flex-shrink-0 items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.bg} ${s.text} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};
